// Copyright 2026, Imprivata, Inc.  All rights reserved.

// The BFF returns only the installation key, not a command line. We compose the
// example silent-install invocation client-side using the confirmed installer
// syntax: the MSI file name embeds the agent version, and the installation key
// is passed as the INSTALL_INFO property. The key is a bearer credential —
// never log the returned string (REQ-033).
export function installCommandLine(installationKey: string, version: string): string {
  return `msiexec.exe /i "Imprivata Endpoint Agent Installer (${version}).msi" INSTALL_INFO=${installationKey}`;
}
